<ui-modal
  class="alerts-modal"
  [isOpened]="showAlerts"
  modalTitle="Alerts"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="alerts">
    <div class="alerts__table-info-group-container">
      <div class="alerts__table-info-container">
        <form [formGroup]="alertsForm">
          <div #divToScroll class="table-container">
            <table class="table-container__alerts" ui-table>
              <thead>
                <tr>
                  <th class="alert-type">Alert Type</th>
                  <th class="identifier">Identifier</th>
                  <th class="parameters">Parameters</th>
                  <th class="status">Status</th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="alertsArray">
                  <tr
                    tableindex="0"
                    *ngFor="let item of alertsFormArray; let i = index"
                    (click)="selectedAlertIndex = i"
                    [ngClass]="{ 'selected-row': selectedAlertIndex === i }"
                  >
                    <ng-container [formGroupName]="i">
                      <td>
                        <ng-select
                          [items]="alertTypeOptions"
                          [searchable]="false"
                          class="alert-type"
                          formControlName="alertType"
                          (change)="alertTypeChange(item)"
                          appendTo="body"
                          [clearable]="false"
                        ></ng-select>
                      </td>

                      <td>
                        <input
                          type="text"
                          class="input-cell identifier"
                          formControlName="identifier"
                        />
                      </td>

                      <td>
                        <button
                          class="input-cell__parameters-button"
                          formGroupName="parameters"
                          (click)="openParameters(item)"
                        >
                          Parameters
                        </button>
                      </td>
                      <td>
                        <ng-select
                          [items]="statusTypeOptions"
                          class="status"
                          [searchable]="false"
                          formControlName="status"
                          [clearable]="false"
                        ></ng-select>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </form>

        <app-alerts-parameters
          *ngIf="showParameterModal"
          [parametersFormGroup]="parametersFormGroup"
          [fixingOutcomeSelected]="fixingOutcomeSelected"
          [parameters]="parametersToView"
          [showModal]="showParameterModal"
          (modalOpenStatusChanged)="parametersModalStatusChanged($event)"
        ></app-alerts-parameters>
        <div class="bottom-table-add">
          <div *ngIf="!loadingAlerts; else alertsLoading">
            <span class="add-text-container">
              <label class="Page-1">+</label>
              <label class="add-text" (click)="addNewAlert()">
                Add Alert
              </label>
            </span>
          </div>
        </div>
        <ng-template #alertsLoading>
          <span class="add-text-container">
            <label class="add-text add-text--loading">Loading</label>
          </span>
        </ng-template>
      </div>
    </div>
    <div class="alerts__table-info-group-container__footer">
      <button
        class="ui-button ui-button__header ui-button--danger ui-button--delete"
        [disabled]="selectedAlertIndex === null"
        (click)="deleteAlert()"
      >
        Delete
      </button>
    </div>

    <div class="alerts__footer">
      <ng-container>
        <button
          class="ui-button primary"
          [disabled]="!allowedToSave"
          (click)="saveChanges()"
        >
          Save
        </button>
        <div class="alerts__footer__spinner-container" *ngIf="false">
          <loading-spinner></loading-spinner>
        </div>
      </ng-container>
    </div>
  </div>
</ui-modal>
